// src/pages/NotFoundPage.tsx
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import AnimatedDotBackground from '@/components/ui/AnimatedDotBackground';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative">
      <AnimatedDotBackground
        intensity="light"
        speed="medium"
        enhancedCorners={false}
      />

      <div className="max-w-md w-full bg-white/80 backdrop-blur-sm p-8 md:p-12 rounded-lg shadow-lg text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}>
          <h1 className="text-9xl font-bold text-secondary">404</h1>
          <h2 className="text-2xl md:text-3xl font-bold mt-4 mb-2">
            Page Not Found
          </h2>
          <p className="text-gray-600 mb-8">
            The page you are looking for might have been removed, had its name
            changed, or is temporarily unavailable.
          </p>

          <Link to="/">
            <Button className="px-6 py-3 font-medium">
              Return to Homepage
            </Button>
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFoundPage;
